const env = window.ENV ?? ({} as Window['ENV']);

export const configuration = {
  API_URL: env.API_URL,
  API_KEY: env.API_KEY,
  GOOGLE_API_KEY: env.GOOGLE_API_KEY,
};
